<sbb-dialog-title i18n="@@QUICK_ACTIONS_TITLE">Schnellwahl</sbb-dialog-title>
<sbb-dialog-close-button></sbb-dialog-close-button>
<sbb-dialog-content>
  <div>
    <!-- this could potentially be @defer'ed - but currently this _increases_ the initial bundle size -->
    <app-quick-action-input />
    <span class="cd-text-muted" i18n="@@QUICK_ACTIONS_HINT">
      Suche nach Seiten (z.B. "Abgeschlossene Aufträge"), Bestellungen (z.B. "B0-0043-8506") oder Aktionen (z.B. "Neuer WLV Auftrag"). Bestätigung per
      Enter oder Klick auf die gewünschte Aktion.
    </span>
  </div>
</sbb-dialog-content>
